import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../helpers/moment'
import { CSVLink } from "react-csv"
import './styles.css'

export const WarnScheduleTable = (props) => {
  const currentDate = moment().format("DD_MM_YYYY")

  function transformDataForCsv() {
    const rows = [["restaurant id", "restaurant name", "start date"]]
    for(const s of props.schedules) {
      rows.push([`${s.restaurant.id}`, `${s.pool.id}`, `${s.startDateUtc}`])
    }
    return rows
  }

  const hasOneSchedule = props.schedules.length === 1
  return <div className = "warn-schedules">
    <div>
      <h5>
        <span className="fa fa-exclamation-triangle mr-3 warn-symbol" />
        {`${props.schedules.length} schedule${hasOneSchedule ? '':'s'} ${hasOneSchedule ? 'was':'were'} uploaded, but ${hasOneSchedule ? 'has':'have'} a warning`}
        <CSVLink filename={"pool_schedule_upload_errors_" + (currentDate + ".csv")} data={transformDataForCsv()} className="csv-link">Save as .csv</CSVLink>
      </h5>
    </div>
    <div>
      {props.schedules.map((s, i) =>
        <div className="table-row" key={i}>
          <div className="column column-id">{s.restaurant.id}</div>
          <div className="column column-name">{s.pool.id}</div>
          <div className="column column-startDate">{moment(s.startDateUtc).format('DD/MM/YYYY')}</div>
          <div className="column column-error">{s.message}</div>
        </div> )}
    </div>
  </div>
}


WarnScheduleTable.propTypes = {
  schedules: PropTypes.array.isRequired,
  validScheduleRows: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/restaurantPoolSchedule/warnSchedulesTable.js